module.exports = __webpack_public_path__ + "img/poorter_hotel-039.d08d5170.jpg";